// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__Ps17k"};